import {ProductCardData, ProductCardParameters} from "../types/product-card-data.types";

export const defaultProductCardParameters: ProductCardParameters = {
  id: null,
  value: null
}

export const defaultProductCardData: ProductCardData = {
  id: 0,
  title: '',
  article: '',
  markGoal: null,
  markGoalCount: null,
  markValue: null,
  ratingValue: null,
  photo: null,
  productId: 0,
  attachedArticles: [],
  productColor: defaultProductCardParameters,
  productScent: defaultProductCardParameters,
  productVolume: defaultProductCardParameters,
  productWeight: defaultProductCardParameters
}
